<form [formGroup]="form" class="flex flex-col">
  <h4 class="block-title mt-0">Titles & Labels</h4>
  <div class="form-row">
    @let headerFontFieldId = `${formId}-header-font`;
    <label [for]="headerFontFieldId">Font</label>
    <blaze-select
      [id]="headerFontFieldId"
      class="w-[120px] font-select"
      formControlName="headerFontFamily"
      [allowNone]="false"
      [options]="fonts"
      [optionValueTemplateRef]="fontOptionTpl"
      [selectedValueTemplateRef]="fontSelectedTpl"
    />
  </div>
  <div class="form-row">
    @let headerFontWeightFieldId = `${formId}-header-font-weight`;
    <label [for]="headerFontWeightFieldId">Weight</label>
    <blaze-select
      [id]="headerFontWeightFieldId"
      class="w-[120px] font-select"
      formControlName="headerFontWeight"
      [allowNone]="false"
      [options]="(headerFontWeightOptions$ | async) || []"
    />
  </div>
  <div class="form-row last-block">
    @let headerFontSizeFieldId = `${formId}-header-font-size`;
    <label [for]="headerFontSizeFieldId">Size</label>
    <div class="flex items-end gap-8">
      <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
        <input
          [id]="headerFontSizeFieldId"
          class="flex-1 w-22 outline-none"
          type="text"
          formControlName="headerFontSize"
          inputmode="numeric"
        />
        <span
          class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
          >PX</span
        >
      </div>
    </div>
  </div>

  <h4 class="block-title">Content</h4>
  <div class="form-row">
    @let fontFieldId = `${formId}-font`;
    <label [for]="fontFieldId">Font</label>
    <blaze-select
      [id]="fontFieldId"
      class="w-[120px] font-select"
      formControlName="fontFamily"
      [allowNone]="false"
      [options]="fonts"
      [optionValueTemplateRef]="fontOptionTpl"
      [selectedValueTemplateRef]="fontSelectedTpl"
    />
  </div>
  <div class="form-row">
    @let fontSizeFieldId = `${formId}-font-size`;
    <label [for]="fontSizeFieldId">Size</label>
    <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
      <input
        [id]="fontSizeFieldId"
        class="flex-1 w-22 outline-none"
        type="text"
        formControlName="fontSize"
        inputmode="numeric"
      />
      <span
        class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
        >PX</span
      >
    </div>
  </div>
  <div class="form-row last-block">
    @let lineHeightFieldId = `${formId}-line-height`;
    <label [for]="lineHeightFieldId">Line height</label>
    <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
      <input
        [id]="lineHeightFieldId"
        class="flex-1 w-22 outline-none"
        type="text"
        formControlName="lineHeight"
        inputmode="numeric"
      />
      <span
        class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
        >PX</span
      >
    </div>
  </div>

  <h4 class="block-title">Containers</h4>
  @if (theme.value.spacing) {
    <div class="form-row">
      @let spacingInternalFieldId = `${formId}-spacing-internal`;
      <label [for]="spacingInternalFieldId">Padding</label>
      <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
        <input
          [id]="spacingInternalFieldId"
          class="flex-1 w-22 outline-none"
          type="text"
          formControlName="spacingInternal"
          inputmode="numeric"
        />
        <span
          class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
          >PX</span
        >
      </div>
    </div>
    <div class="form-row">
      @let spacingExternalFieldId = `${formId}-spacing-external`;
      <label [for]="spacingExternalFieldId">Gap Between</label>
      <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
        <input
          [id]="spacingExternalFieldId"
          class="flex-1 w-22 outline-none"
          type="text"
          formControlName="spacingExternal"
          inputmode="numeric"
        />
        <span
          class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
          >PX</span
        >
      </div>
    </div>
  }
  <div class="form-row">
    @let borderRadiusFieldId = `${formId}-border-radius`;
    <label [for]="borderRadiusFieldId">Corner radius</label>
    <div class="border-a-12 rounded flex flex-row flex-nowrap p-8 gap-4 w-[120px]">
      <input
        [id]="borderRadiusFieldId"
        class="flex-1 w-22 outline-none"
        type="text"
        formControlName="radius"
        inputmode="numeric"
      />
      <span
        class="px-4 flex-0 text-center uppercase text-10 font-medium leading-5 bg-overlay-light-background rounded"
        >PX</span
      >
    </div>
  </div>

  <div class="form-row">
    <div class="flex items-center w-full py-8 gap-8">
      <blaze-checkbox
        (change)="toggleContainerOutline($event)"
        [checked]="isContainerOutlineEnabled"
      >
        <span class="text-primary">Show border outline</span>
      </blaze-checkbox>
    </div>
  </div>

  @if (isContainerOutlineEnabled) {
    @let fieldId = `${formId}-container-outline-width`;
    <div class="form-row -mt-8">
      <label [for]="fieldId">Width</label>
      <blaze-slider
        [id]="fieldId"
        class="slider-input"
        [(value)]="containerOutlineFormValue"
        [units]="[{ min: 1, max: 10, unit: 'px' }]"
      />
    </div>
  }

  <div class="form-row label-top">
    @let visualEffectTypeFieldId = `${formId}-visual-effect-type`;
    <label [for]="visualEffectTypeFieldId">Effect</label>
    <div class="flex items-center w-full gap-8">
      <blaze-select
        [id]="visualEffectTypeFieldId"
        class="grow"
        formControlName="effectType"
        [allowNone]="false"
        [options]="effects"
      />
      <button
        blazeIconButton
        type="button"
        data-cy="ThemeEditor:VisualEffectDialogTrigger"
        [disabled]="visualEffectConfigDialogBlocked"
        (click)="showVisualEffectConfigDialog()"
      >
        <mat-icon svgIcon="icon_more_h_24" />
      </button>
    </div>
  </div>
  <div class="mt-8">
    <label class="color-row">
      <blaze-color-picker formControlName="fill" [noAlpha]="true" />
      <span>Fills</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="outline" [noAlpha]="true" />
      <span>Outlines</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="title" [noAlpha]="true" />
      <span>Titles</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="value" [noAlpha]="true" />
      <span>Values</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="accent" [noAlpha]="true" />
      <span>Accent</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="accentLabel" [noAlpha]="true" />
      <span>Accent label</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="complementary" [noAlpha]="true" />
      <span>Complementary</span>
    </label>
    <label class="color-row">
      <blaze-color-picker formControlName="canvas" [noAlpha]="true" />
      <span>Canvas</span>
    </label>
  </div>

  <div class="mt-16" formGroupName="palette">
    <label class="color-row">
      <blaze-color-picker formControlName="fg" [noAlpha]="true" />
      <span>Tag label</span>
    </label>
  </div>

  <div class="mt-16" formGroupName="palette">
    <div class="mb-8 text-13 text-primary-darker font-normal"> Tag & chart fills </div>
    <ng-container formArrayName="bg">
      <label class="color-row-inline">
        @for (paletteControl of paletteControls; track paletteControl; let i = $index) {
          <blaze-color-picker [formControl]="paletteControl" size="sm" />
        }
      </label>
    </ng-container>
  </div>
</form>

<ng-template #fontOptionTpl let-option>
  <span [style.font-family]="option.value">{{ option.label || 'None' }}</span>
</ng-template>

<ng-template #fontSelectedTpl let-item="item" let-multiselect="multiselect">
  <span [class.limit-width]="multiselect" [style.font-family]="item.value">{{
    item.label || 'None'
  }}</span>
</ng-template>
